import React from "react";
import SideBar from "../sideBar/sideBar";
import adminNavigationConfig from "../../routes/adminNavigationConfig";
interface AdminLayoutProps {
    children: React.ReactNode;
}
console.log(window.location.hash);
const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
    return (
        <div className="flex bg-secondaryColor overflow-hidden">
            <SideBar navigation={adminNavigationConfig} />
            <div className={`bg-white w-full mt-7 rounded-tl-[30px] md:rounded-tl-[40px] overflow-auto h-[calc(100vh-28px)] ${window.location.hash === '#/admin-profile' ? '' : 'p-6 md:p-10'}`}>
                {children}
            </div>
        </div>
    );
}

export default AdminLayout;
